import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { useTooltipTap } from '@/components/use-tooltip-tap'
import { ZIndexRange } from '@/types/style'

interface NotCalculatedSumProps {
  reason: string
}

export const NotCalculatedSum: React.FC<NotCalculatedSumProps> = ({
  reason,
}) => {
  const { rootProps, triggerProps, contentProps } = useTooltipTap()

  return (
    <Tooltip {...rootProps}>
      <TooltipTrigger
        {...triggerProps}
        type="button"
        aria-label={reason}
        className="cursor-help text-gray-400"
      >
        –
      </TooltipTrigger>
      <TooltipContent
        {...contentProps}
        className="max-w-xs text-left text-wrap"
        style={{ zIndex: ZIndexRange.Extra }}
      >
        {reason}
      </TooltipContent>
    </Tooltip>
  )
}
